import { render, staticRenderFns } from "./caddie_house.vue?vue&type=template&id=0b558ef4&scoped=true"
import script from "./caddie_house.vue?vue&type=script&lang=js"
export * from "./caddie_house.vue?vue&type=script&lang=js"
import style0 from "./caddie_house.vue?vue&type=style&index=0&id=0b558ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b558ef4",
  null
  
)

export default component.exports